import { ModalNavigationEnum } from '../../../shared/constants';

export const ICP_VERTICAL_TAB_PARAM: string = `${ModalNavigationEnum.ICP_AUTOMATIONS}.vertical-tab-menu`;
export const ICP_HORIZONTAL_TAB_PARAM: string = `${ModalNavigationEnum.ICP_AUTOMATIONS}.horizontal-tab-menu`;
export const ICP_AUTOMATION_NAME_TO_SCROLL_PARAM: string = `${ModalNavigationEnum.ICP_AUTOMATIONS}.automation-name-to-scroll`;
export const ICP_AUTOMATION_SAVED_SEARCH_ID: string = `${ModalNavigationEnum.ICP_AUTOMATIONS}.saved-search-id`;
export const ICP_AUTOMATION_EXPORT_ERRORS_TAB_PARAM: string = `${ModalNavigationEnum.ICP_AUTOMATIONS}.exportErrors`;
